import { DatePicker as AntDatePicker } from 'antd';

import { useDateFormat } from '@frontend/utils';

import type {
  DateRangeValue,
  ExcludableDateRelation,
  DateRangeInputValue,
  DateRangeInputProps,
} from '../types';

const AntRangePicker = AntDatePicker.RangePicker;

const DateRangeInput = <ExcludedRelations extends ExcludableDateRelation>({
  relationFilterValue,
  onChange,
  style,
}: DateRangeInputProps<ExcludedRelations>) => {
  const { dateFormat } = useDateFormat();
  return (
    <AntRangePicker
      value={
        relationFilterValue.startDate
          ? [relationFilterValue.startDate, relationFilterValue.endDate]
          : null
      }
      onChange={(selectedDateRange: DateRangeInputValue) => {
        const newDateRangeValue: DateRangeValue =
          selectedDateRange?.[0] && selectedDateRange?.[1]
            ? {
                startDate: selectedDateRange[0],
                endDate: selectedDateRange[1],
              }
            : { startDate: null, endDate: null };

        onChange(newDateRangeValue);
      }}
      format={dateFormat}
      style={style}
    />
  );
};

export default DateRangeInput;
